import React from "react";

type Props = {
    className?: string;
};

export default function DownloadArrow(props: Props) {
    return (
        <svg
            className={props.className}
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
        >
            <g fill="none" fillRule="evenodd">
                <g stroke="#202B34" strokeWidth="1.5">
                    <g>
                        <g>
                            <path
                                d="M0 15v3c0 1.105.895 2 2 2h14c1.105 0 2-.895 2-2v-3M5 10L9 14 13 10M9 0L9 14"
                                transform="translate(-131 -1948) translate(120 1934) translate(12 14)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
